import { computed } from 'vue'
import type { Permission } from '~/enums'
import { hasAnyPermission } from '~/utils/hasAnyPermission'
import { holdsCustomerRole } from '~/utils/holdsCustomerRole'
import { resolveRoleNames } from '~/utils/resolveRoleNames'

export const useUserPermissions = () => {
  const userStore = useUserStore()

  const roleNames = computed(() => resolveRoleNames(userStore.user))
  const isCustomerRole = computed(() => holdsCustomerRole(roleNames.value))
  const hasConsumerAccess = computed(() => userStore.hasConsumerAccess)

  const has = (permission: Permission): boolean => userStore.access.permissions.includes(permission)
  const hasAny = (permissions: readonly Permission[]): boolean =>
    hasAnyPermission(userStore.access.permissions, permissions)
  const hasAll = (permissions: readonly Permission[]): boolean =>
    permissions.every((permission) => has(permission))

  return {
    roleNames,
    isCustomerRole,
    hasConsumerAccess,
    has,
    hasAny,
    hasAll
  }
}
